import { Constants } from '../../app.const';

export class DashboardConstants {

    public static basicConstans: any = Constants;

    public static baseUrl: string = Constants.baseUrl;
    public static apiUrl: string = Constants.baseUrl+Constants.apiVersioning;
    public static appUrl: string = Constants.appUrl;
    public static loginUrl: string = Constants.loginUrl;
    public static imageUrl: string = Constants.imageUrl;
    public static apiVersioning: string = Constants.apiVersioning;
    public static endPoint: string = Constants.endPoint;

    //ROUTES
    public static routeDashboard: string = Constants.routeDashboard;
    public static routeMy: string = Constants.routeMy;
    public static routeManage: string = Constants.routeManage;

    //LINK
    public static linkRedirectTo: string = '/' + Constants.linkMyDashboard;

    //ROUTE_DATA
    public static routeDataDashboard: string = 'Dashboard';
    public static routeDataMyDashboard: string = 'View My Dashboard';
    public static routeDataManageDashboard: string = 'Manage Dashboard';



};


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.const.ts